import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { renderBySource } from 'common/utils'
import Indicator from 'components/Common/Indicator'
import styles from './index.css'
import Material from 'components/Practice/Material'
import AnswerAnalysis from 'components/Practice/Material/AnswerAnalysis.js'
import ChooseQuestion from 'components/Answer/Question/ChooseQuestion';
import BlankQuestion from 'components/Answer/Question/BlankQuestion';
import ExplainByTitle from 'components/Practice/Material/ExplainByTitle.js';
import AdPosition from 'components/Practice/Material/AdPosition.js';
import SpeakingQuestion from 'components/Answer/Question/SpeakingQuestion'
import ad1 from '../../Practice/Material/ad1.jpg';
import ad2 from '../../Practice/Material/ad2.jpg';

@withRouter
@observer(['answerStore'])
export default class Main extends Component {
  constructor() {
    super();
    this.state = {
      showText: false
    }
  }
  handleChange (idx) {
    const { location, router } = this.props

    router.replace({
      pathname: location.pathname,
      query: {
        ...location.query,
        page: idx + 1
      }
    })
  }
  additionCallback = ()=> {
    this.setState({
      showText: !this.state.showText
    })
  }
  renderSingleLayout () {
    const { currentReport } = this.props.answerStore
    const { answerStore, location } = this.props

    return (
      <div>
        <Material
          material={currentReport.material}
          additionMaterial={currentReport.additionMaterial}
          category={currentReport.category}
          additionCallback={this.additionCallback}
          />
        <div className={styles.questionContent}>
          {
            this.state.showText ?
              <div>
                {
                  currentReport.additionMaterial.text.map((item,index)=>{
                    return (
                      <div key={index} dangerouslySetInnerHTML={{ __html: item.raw }} >
                      </div>
                    )
                  })
                }
              </div>:
              <div>
                {this.renderQuestionOption()}
                <div className={styles.explain}>
                  {
                    renderBySource(location.query, 'ctqa', () => (
                      <ExplainByTitle userGroup={answerStore.userGroup} userGroupName={answerStore.userGroupName} qid={currentReport.id} tipId={currentReport.tipId} ctqa={currentReport.sliceInfo} exam={this.props.exam}/>
                    ))
                  }
                  {
                    renderBySource(location.query, 'askTeacher', () => (
                      <AdPosition src={ad2} handleClick={ () => { answerStore.toggleAskTeacher(true) } }/>
                    ))
                  }
                </div>
              </div>

          }
        </div>
      </div>
    )
  }
  renderDoubleLayout () {
    const { currentReport } = this.props.answerStore
    const { answerStore, location } = this.props

    return (
      <div className={ styles.doubleLayout }>
        <div>
          <Material
            material={currentReport.material}
            additionMaterial={currentReport.additionMaterial}
            category={currentReport.category}
            />
          {
            currentReport.category === 'writing' ?
              (
                currentReport.detail.map((item,index)=> {
                  return (
                    <Material stem={item.question} key={index}/>
                  )
                })
              ): null
          }
        </div>
        <div>
          {this.renderQuestionOption()}
          <div className={styles.explain}>
            {
              renderBySource(location.query, 'ctqa', () => (
                <ExplainByTitle userGroup={answerStore.userGroup} userGroupName={answerStore.userGroupName} qid={currentReport.id} tipId={currentReport.tipId} ctqa={currentReport.sliceInfo} exam={this.props.exam}/>
              ))
            }
            {
              renderBySource(location.query, 'askTeacher', () => (
                <AdPosition src={ad1} handleClick={ () => { answerStore.toggleAskTeacher(true) } }/>
              ))
            }
          </div>
        </div>

      </div>
    )
  }
  renderQuestionOption() {
    const { currentReport } = this.props.answerStore;
    return currentReport.detail.map((item, index) => {
      switch (currentReport.category) {
        case 'radio':
        case 'multi':
          return (
            <ChooseQuestion
              key={index}
              category={ currentReport.category }
              stem={ item.question }
              choices={ item.choices }
              correctAnswer={ item.answer }
              userAnswer={ currentReport.userAnswer[index] }
              analysisAnswer={ item.answer_analysis }
              />
          )
        case 'writing':
          return (
            <AnswerAnalysis
              category={currentReport.category}
              analysisAnswer={ item.answer_analysis }
              key={index}
              myWriting={currentReport.userAnswer[index].answer}
              />
          )
        case 'blank':
          return (
            <BlankQuestion
              key={index}
              category={currentReport.category}
              analysisAnswer={ item.answer_analysis }
              question={item.question}
              choices={item.choices}
              userAnswer={currentReport.userAnswer[index]}
              isSingleLayout={currentReport.isSingleLayout}
              />
          )
        case 'speaking':
          return (
            <SpeakingQuestion
              key={index}
              analysisAnswer={ item.answer_analysis }
              question={item.question}
              userAnswer={currentReport.userAnswer[index]}
              />
          )
        default:
          return null
      }
    })
  }
  render () {
    const { answerStore } = this.props
    return (
      <div className={ styles.root }>
        <Indicator
          current={ answerStore.idx }
          statuses={ answerStore.correctList }
          onChange={ idx => this.handleChange(idx) } />
        <div className={ styles.layoutWrap }>
          { answerStore.currentReport.isSingleLayout ? this.renderSingleLayout() : this.renderDoubleLayout() }
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Answer/Main/index.js
 **/